var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTuanisExpressLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: "314.3mm",
    height: "82.011mm",
    viewBox: "0 0 314.3 82.011",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath292-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292-1-4",
    transform: "translate(-122.67 -637.03)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath294-7-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path294-1-7",
    transform: "translate(-260 -593.97)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath296-9-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296-0-0",
    transform: "translate(-493.83 -609.95)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath298-4-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path298-7-3",
    transform: "translate(-718.92 -583.58)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath300-6-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path300-5-8",
    transform: "translate(-756.62 -578.72)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath302-1-71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path302-4-02",
    transform: "translate(-823.23 -530.37)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath304-5-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304-5-59",
    transform: "translate(-844.51 -627.86)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath306-9-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path306-9-5",
    transform: "translate(-337.96 -439.36)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath308-9-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path308-9-8",
    transform: "translate(-378.21 -425.35)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath310-2-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path310-4-94",
    transform: "translate(-490.4 -460.63)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath312-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path312-6-77",
    transform: "translate(-564.42 -459.52)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath314-2-09"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path314-2-2",
    transform: "translate(-637.2 -439.36)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath316-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path316-1-21",
    transform: "translate(-689.39 -447.01)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath318-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path318-0-7",
    transform: "translate(-757.53 -447.01)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath320-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320-4-8",
    transform: "translate(-338.47 -473.83)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath322-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path322-7-3",
    transform: "translate(-336.1 -471.97)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath324-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324-3-1",
    transform: "translate(-330.82 -455.82)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath326-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path326-7-2",
    transform: "translate(-329.06 -439.66)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath328-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path328-1-0",
    transform: "translate(-352.37 -457.67)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath330-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path330-5-0",
    transform: "translate(-324.58 -441.52)",
    d: "m0 1080h1080v-1080h-1080z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath332-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path332-8-3",
    transform: "translate(-338.47 -425.36)",
    d: "m0 1080h1080v-1080h-1080z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer-MC1-0",
    transform: "matrix(.26458 0 0 .26458 -583.62 -593.47)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#003759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path291-8-4",
    transform: "matrix(1.3333 0 0 -1.3333 2243.3 2268.7)",
    d: "m0 0h105.23c6.321 0 10.72-6.282 8.558-12.221l-5.435-14.933h-36.309l-33.211-91.246h-45.615l7.442 20.447-22.691 6.226s7.837-0.223 15.333-0.464c1.291-0.091 5.452-0.225 10.269-0.364 8.608-0.245 19.277-0.495 19.277-0.495l-13.528 3.548-10.852 2.847-7.82 2.779s8.134 0.273 15.306 0.468l11.907 32.717-16.704 5.213s4.193-0.078 9.088-0.187l-3e-3 -0.056c0.504-0.128 8.472-0.327 15.136-0.474 4.896-0.108 9.089-0.187 9.089-0.187l-13.504 4.213 5.465 15.014h-36.309l3.274 8.994c6.194 0.316 20.522 1.385 20.522 1.385l-12.756 2.741v-0.032l-9.311 2.032-19.971 4.356s17.598 0.365 25.483 0.412z",
    clipPath: "url(#clipPath292-0-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path293-1-7",
    transform: "matrix(1.3333 0 0 -1.3333 2426.4 2326.1)",
    d: "m0 0c8.607-0.245 19.269-0.495 19.269-0.495l-13.528 3.548-10.853 2.848-7.819 2.778s5.776 0.195 11.883 0.371l5.374 14.765c6.479 0.352 19.9 1.353 19.9 1.353l-12.756 2.741v-0.033l-9.311 2.032-19.971 4.356s18.547 0.384 26.092 0.416l3.048 8.376h33.124c6.32 0 10.719-6.281 8.557-12.221l-22.015-60.484c-3.72-10.216 1.568-18.53 11.785-18.53h22.552l5.047 13.866-14.697 4.585s4.193-0.078 9.089-0.187l-4e-3 -0.056c0.504-0.125 8.472-0.327 15.136-0.474 4.896-0.108 9.088-0.187 9.088-0.187l-15.51 4.84 7.436 20.431-10.924 4.773s2.552-0.104 5.694-0.236c4.566-0.189 10.391-0.432 11.563-0.484l-2e-3 -0.02c14.408-0.593 34.434-1.347 34.434-1.347l-37.575 6.074 0.011 0.027-32.82 5.491s26.114 0.492 35.009 0.521l12.237 33.618h33.499c6.321 0 10.719-6.281 8.557-12.221l-38.644-106.18h-80.19c-29.514 0-44.786 24.011-34.044 53.528l6.282 17.258-19.612 5.381s7.837-0.223 15.332-0.464c1.29-0.091 5.456-0.228 10.277-0.361",
    clipPath: "url(#clipPath294-7-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path295-1-8",
    transform: "matrix(1.3333 0 0 -1.3333 2738.2 2304.8)",
    d: "m0 0c-10.217 0-21.556-8.313-25.274-18.531l-4.709-12.939h40.977l2.802 7.698-18.641 5.817s4.192-0.078 9.089-0.188l-4e-3 -0.055c0.504-0.126 8.473-0.328 15.136-0.475 4.896-0.108 9.088-0.187 9.088-0.187l-11.568 3.61 5.551 15.25zm-1.746 27.066h67.185c6.321 0 10.719-6.282 8.557-12.221l-38.727-106.4h-46.143l3.677 10.102-12.985 5.675s2.554-0.105 5.701-0.236c4.563-0.19 10.385-0.432 11.555-0.485l-1e-3 -0.02c14.408-0.592 34.433-1.347 34.433-1.347l-35.321 5.71 6e-3 0.015-35.072 5.868s32.765 0.617 37.392 0.509l2.688 7.386h-40.976l-12.073-33.174h-46.599l21.392 58.775-25.805 7.08s7.836-0.22 15.333-0.462c1.29-0.091 5.455-0.225 10.28-0.364 1.048-0.043 1.877-0.084 2.427-0.117l0.017 0.049c8.053-0.222 16.825-0.427 16.825-0.427l-24.38 6.396-7.82 2.779s11.872 0.398 19.573 0.575c13.526 25.152 42.478 44.34 68.861 44.337",
    clipPath: "url(#clipPath296-9-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path297-9-3",
    transform: "matrix(1.3333 0 0 -1.3333 3038.3 2339.9)",
    d: "m0 0-23.644-64.958h-46.128l7.805 21.447-14.268 4.454s4.193-0.079 9.089-0.188l-3e-3 -0.056c0.503-0.128 8.472-0.327 15.135-0.474 4.896-0.108 9.089-0.187 9.089-0.187l-15.939 4.973 13.158 36.151-23.551 6.462s7.84-0.222 15.334-0.463c1.292-0.091 5.453-0.226 10.27-0.364 8.609-0.245 19.278-0.496 19.278-0.496l-24.38 6.396-7.82 2.778s7.438 0.249 14.36 0.442c-0.763 6.173-5.529 10.448-12.846 10.448h-22.552l-33.24-91.323h-46.505l15.727 43.144-10.04 4.386s2.551-0.105 5.694-0.236c4.565-0.189 10.39-0.432 11.563-0.485l-3e-3 -0.019c14.409-0.593 34.434-1.347 34.434-1.347l-38.538 6.229 0.012 0.031-31.859 5.331s24.279 0.458 33.99 0.516l20.007 54.881c1.311 3.595 4.729 5.988 8.556 5.988h73.816c29.516 0 44.745-23.946 33.999-53.461",
    clipPath: "url(#clipPath298-4-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path299-9-0",
    transform: "matrix(1.3333 0 0 -1.3333 3088.6 2346.4)",
    d: "m0 0-35.17 5.885s33.342 0.628 37.496 0.506l18.894 51.913h33.948c6.321 0 10.719-6.281 8.557-12.221l-38.643-106.18h-46.953l18.475 50.763-13.075 5.713s2.555-0.105 5.701-0.237c4.563-0.189 10.385-0.432 11.556-0.484l-1e-3 -0.02c14.407-0.593 34.432-1.347 34.432-1.347l-35.22 5.694z",
    clipPath: "url(#clipPath300-6-04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path301-0-41",
    transform: "matrix(1.3333 0 0 -1.3333 3177.4 2410.9)",
    d: "m0 0c8.608-0.245 19.269-0.496 19.269-0.496l-13.527 3.549-10.853 2.848-7.82 2.778s8.506 0.284 15.789 0.48l2.241 6.159h76.172c1.711 0 3.935 1.545 5.875 4.114l-15.596 4.866s4.193-0.079 9.089-0.187l-4e-3 -0.057c0.505-0.127 8.473-0.327 15.137-0.473 4.896-0.109 9.088-0.188 9.088-0.188l-14.013 4.373c0.611 3.789-0.719 6.268-2.766 6.268-1.661 0-36.584-0.123-36.584-0.123-12.428 0-21.944 4.366-26.423 12.041l-20.783 6.385s4.257-0.079 9.23-0.187l-4e-3 -0.056c0.514-0.128 8.608-0.327 15.375-0.474 4.973-0.108 9.23-0.188 9.23-0.188l-15.855 4.872c-0.044 1.763 0.096 3.62 0.424 5.557l-9.851 4.307s2.553-0.105 5.699-0.236c4.564-0.19 10.385-0.432 11.556-0.485l-1e-3 -0.02c14.408-0.592 34.432-1.347 34.432-1.347l-39.28 6.35c6e-3 0.013 0.011 0.025 0.016 0.037l-31.12 5.207s24.107 0.453 33.885 0.515c9.999 17.511 30.79 30.565 49.98 30.565h75.112c6.321 0 10.719-6.281 8.558-12.221l-5.442-14.951h-75.484c-2.733 0-6.518-3.225-8.616-8.987-1.937-5.319-0.459-9.04 2.054-9.04 1.66 0 35.368 0.122 35.368 0.122 21.853 0 34.515-14.063 26.772-35.335-7.701-21.161-31.64-38.085-53.494-38.085h-87.59l2.269 6.231-23.128 6.345s7.836-0.223 15.331-0.464c1.289-0.091 5.455-0.228 10.283-0.369",
    clipPath: "url(#clipPath302-1-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path303-1-7",
    transform: "matrix(1.3333 0 0 -1.3333 3205.8 2280.9)",
    d: "m0 0-3.61-9.835 1.84-6e-3c4.026 0.332 13.821 3.052 20.843 20.744l1.284 3.502c2.687 7.719-1.323 13.95-9.068 13.975-7.838 0.023-16.524-6.317-19.405-14.163-2.772-7.552 0.851-13.743 8.116-14.217",
    clipPath: "url(#clipPath304-5-4)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f91600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path305-6-9",
    transform: "matrix(1.3333 0 0 -1.3333 2530.4 2532.2)",
    d: "m0 0h19.467l-2.192-14.009h-36.269l9.927 62.912h36.269l-2.278-14.525h-19.466l-1.59-10.27h18.048l-2.105-13.666h-18.135z",
    clipPath: "url(#clipPath306-9-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path307-3-5",
    transform: "matrix(1.3333 0 0 -1.3333 2584.1 2550.9)",
    d: "m0 0 27.889 33.992-16.802 28.92h19.08l6.618-12.376c0.4-0.773 0.794-1.567 1.182-2.386 0.385-0.814 0.752-1.64 1.095-2.47 0.372 0.801 0.81 1.604 1.312 2.407 0.5 0.801 1.079 1.646 1.739 2.535l9.369 12.29h20.584l-24.28-29.909 19.596-33.003h-19.682l-9.067 16.802c-0.373 0.659-0.751 1.403-1.14 2.235-0.385 0.83-0.78 1.703-1.181 2.621-0.545-1.117-1.06-2.078-1.547-2.879-0.488-0.803-0.961-1.519-1.418-2.148l-12.505-16.631z",
    clipPath: "url(#clipPath308-9-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path309-7-3",
    transform: "matrix(1.3333 0 0 -1.3333 2733.6 2503.8)",
    d: "m0 0h1.59c5.442 0 9.124 0.572 11.044 1.719 1.918 1.145 2.879 3.094 2.879 5.844 0 2.321-0.823 4.017-2.472 5.093-1.646 1.073-4.232 1.611-7.755 1.611h-3.008zm-22.346-35.281 10.013 62.913h17.275c4.784 0 8.38-0.193 10.786-0.581 2.407-0.385 4.497-1.039 6.274-1.955 3.208-1.633 5.609-3.867 7.197-6.704 1.592-2.836 2.386-6.231 2.386-10.184 0-3.926-0.852-7.563-2.558-10.915-1.703-3.352-4.017-5.931-6.939-7.735-1.719-1.061-3.754-1.812-6.102-2.256-2.35-0.445-6.032-0.667-11.044-0.667h-7.048l-3.523-21.916z",
    clipPath: "url(#clipPath310-2-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path311-4-2",
    transform: "matrix(1.3333 0 0 -1.3333 2832.3 2505.3)",
    d: "m0 0h5.286c3.322 0 5.871 0.758 7.649 2.278 1.776 1.517 2.664 3.709 2.664 6.574 0 2.692-0.832 4.648-2.492 5.867-1.662 1.217-4.327 1.826-7.993 1.826h-2.493zm-5.372-34.163h-16.716l9.927 62.912h16.759c5.042 0 8.794-0.179 11.259-0.536 2.463-0.36 4.598-0.968 6.403-1.828 3.18-1.49 5.586-3.587 7.219-6.296 1.633-2.706 2.45-5.951 2.45-9.733 0-5.215-1.554-9.576-4.662-13.084-3.109-3.51-7.386-5.71-12.828-6.597l15.298-24.838h-19.166l-12.161 24.021z",
    clipPath: "url(#clipPath312-0-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path313-8-9",
    transform: "matrix(1.3333 0 0 -1.3333 2929.4 2532.2)",
    d: "m0 0h19.467l-2.192-14.009h-36.269l9.927 62.912h36.269l-2.278-14.525h-19.466l-1.59-10.27h18.048l-2.106-13.666h-18.134z",
    clipPath: "url(#clipPath314-2-09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path315-9-9",
    transform: "matrix(1.3333 0 0 -1.3333 2999 2522)",
    d: "m0 0c2.635-2.836 5.15-4.899 7.543-6.188 2.391-1.289 4.861-1.934 7.412-1.934 2.119 0 3.809 0.516 5.07 1.547 1.26 1.032 1.891 2.391 1.891 4.083 0 2.291-2.551 4.77-7.649 7.434-0.488 0.258-0.875 0.457-1.16 0.602-4.958 2.578-8.352 5.055-10.185 7.434-1.834 2.377-2.75 5.27-2.75 8.68 0 6.216 2.099 11.302 6.295 15.256 4.197 3.953 9.605 5.93 16.223 5.93 3.494 0 6.855-0.617 10.076-1.848 3.225-1.232 6.267-3.051 9.133-5.457l-7.22-12.42c-2.264 1.948-4.326 3.395-6.188 4.341-1.863 0.945-3.582 1.418-5.157 1.418-1.719 0-3.152-0.495-4.297-1.482-1.146-0.99-1.719-2.2-1.719-3.632 0-1.777 2.149-3.768 6.446-5.973 1.518-0.774 2.692-1.405 3.524-1.891 4.411-2.436 7.477-4.92 9.196-7.457 1.719-2.533 2.578-5.708 2.578-9.517 0-6.733-2.336-12.112-7.004-16.136-4.67-4.026-11.017-6.038-19.037-6.038-4.212 0-8.151 0.895-11.818 2.686-3.668 1.79-6.977 4.447-9.927 7.971z",
    clipPath: "url(#clipPath316-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path317-5-8",
    transform: "matrix(1.3333 0 0 -1.3333 3089.8 2522)",
    d: "m0 0c2.635-2.836 5.15-4.899 7.543-6.188 2.391-1.289 4.861-1.934 7.412-1.934 2.119 0 3.809 0.516 5.07 1.547 1.26 1.032 1.891 2.391 1.891 4.083 0 2.291-2.551 4.77-7.649 7.434-0.488 0.258-0.875 0.457-1.16 0.602-4.958 2.578-8.352 5.055-10.185 7.434-1.834 2.377-2.75 5.27-2.75 8.68 0 6.216 2.099 11.302 6.295 15.256 4.197 3.953 9.605 5.93 16.223 5.93 3.494 0 6.855-0.617 10.076-1.848 3.225-1.232 6.267-3.051 9.133-5.457l-7.22-12.42c-2.264 1.948-4.326 3.395-6.188 4.341-1.863 0.945-3.582 1.418-5.157 1.418-1.719 0-3.152-0.495-4.297-1.482-1.146-0.99-1.719-2.2-1.719-3.632 0-1.777 2.149-3.768 6.446-5.973 1.518-0.774 2.692-1.405 3.524-1.891 4.411-2.436 7.477-4.92 9.196-7.457 1.719-2.533 2.578-5.708 2.578-9.517 0-6.733-2.336-12.112-7.004-16.136-4.67-4.026-11.017-6.038-19.037-6.038-4.212 0-8.151 0.895-11.818 2.686-3.668 1.79-6.977 4.447-9.927 7.971z",
    clipPath: "url(#clipPath318-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path319-0-0",
    transform: "matrix(1.3333 0 0 -1.3333 2531.1 2486.3)",
    d: "m0 0h-44.011l2.144 4.216h44.011z",
    clipPath: "url(#clipPath320-7)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path321-7-8",
    transform: "matrix(1.3333 0 0 -1.3333 2527.9 2488.7)",
    d: "m0 0h-20.618l1.004 1.852h20.618z",
    clipPath: "url(#clipPath322-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path323-7-9",
    transform: "matrix(1.3333 0 0 -1.3333 2520.9 2510.3)",
    d: "m0 0h-20.618l1.004 1.852h20.618z",
    clipPath: "url(#clipPath324-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path325-5-7",
    transform: "matrix(1.3333 0 0 -1.3333 2518.5 2531.8)",
    d: "m0 0h-20.618l1.004 1.852h20.618z",
    clipPath: "url(#clipPath326-3)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f91600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path327-8-0",
    transform: "matrix(1.3333 0 0 -1.3333 2549.6 2507.8)",
    d: "m0 0h-44.011l2.144 4.216h44.011z",
    clipPath: "url(#clipPath328-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path329-6-8",
    transform: "matrix(1.3333 0 0 -1.3333 2512.5 2529.3)",
    d: "m0 0h-44.011l2.144 4.216h44.011z",
    clipPath: "url(#clipPath330-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path331-4-8",
    transform: "matrix(1.3333 0 0 -1.3333 2531.1 2550.9)",
    d: "m0 0h-44.011l2.144 4.216h44.011z",
    clipPath: "url(#clipPath332-9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuanisExpressLogo);
export default __webpack_public_path__ + "static/media/TuanisExpressLogo.02c32d611f4e9fa60a07966eb52f822b.svg";
export { ForwardRef as ReactComponent };